import * as C from '../constants';
import * as Api from '../api/cart';
import * as Selectors from '../reducers/selectors';

export const selectPlan = (plan: PlanKey): PlanSelectAction => ({
  type: C.ACTION_TYPES.PLAN_SELECT,
  payload: {
    plan,
  },
});

export const receivedPlanPricing = (data: any): PlanReceivedPricing => ({
  type: C.ACTION_TYPES.PLAN_RECEIVED_PRICING,
  payload: {
    plans: data,
  },
});

export const fetchPlanPricing = (): Action => ({
  type: C.ACTION_TYPES.PLAN_FETCH_PLAN_PRICING,
});

export const failedFetchPlanPricing = (): Action => ({
  type: C.ACTION_TYPES.PLAN_FETCH_PLAN_PRICING_ERROR,
});

export const calculatePlanPricing = () => async (
  dispatch: Function,
  getState: Function
) => {
  dispatch(fetchPlanPricing());
  const state = getState();
  try {
    const data = await Api.getCartCost(
      Selectors.getCartDataItems(state),
      Selectors.getCartShopItems(state),
      Selectors.getCartShopItemCategories(state)
    );
    dispatch(receivedPlanPricing(data));
  } catch (err) {
    dispatch(failedFetchPlanPricing());
  }
};



// WEBPACK FOOTER //
// ./app/actions/PlanActionCreators.ts